export default __webpack_public_path__ + "static/media/[BTCLOD.COM] Davido - Jowo (Official Audio)-320k.c6b012bf.mp3";